// extracted by mini-css-extract-plugin
export default {"wrapper":"CD-z","button":"DD-z","alternate":"ED-z","disabled":"FD-z","paymentWarning":"GD-z","fadeIn":"HD-z"};